import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { CoverablesService } from 'gw-capability-codegen';
import _ from 'lodash';
import { useCallback, useState } from 'react';

export default ({
    ownerVM,
    coverableVM,
    coverableType,
    jobID,
    sessionUUID,
    lobName,
    updateIsSaving,
    clausesBasePath,
    authHeader,
}) => {
    const [, updateState] = useState();
    const [loadingClause, setLoadingClause] = useState();

    const syncCoverages = useCallback(
        async (value, changedPath) => {
            updateIsSaving(true);
            const basePath =
                ClausesUtil.getObjectPathFromChangedPath(changedPath);
            const baseObject = _.get(ownerVM, basePath);

            const escapedClausesBasePath = clausesBasePath
                .replace(/\[/g, '\\[')
                .replace(/\]/g, '\\]');
            const clausesPath = changedPath.match(
                `${escapedClausesBasePath}.(exclusions|coverages|conditions)`
            )[0];
            const clausesVM = _.get(ownerVM, clausesPath);
            if (ClausesUtil.shouldClauseUpdate(baseObject, clausesVM.value)) {
                setLoadingClause(
                    baseObject.coveragePublicID || baseObject.publicID
                );
                const updatedCoverable = await CoverablesService.callMethod(
                    lobName,
                    coverableType,
                    'updateCoverages',
                    [jobID, sessionUUID, coverableVM.value],
                    authHeader
                );
                // eslint-disable-next-line no-param-reassign
                coverableVM.value = updatedCoverable;
                updateState({});
                setLoadingClause(null);
            }
            updateIsSaving(false);
        },
        [
            coverableType,
            ownerVM && ownerVM.value,
            coverableVM && coverableVM.value,
            jobID,
            lobName,
            sessionUUID,
        ]
    );

    const updateCoverage = useCallback(
        (value, path) => {
            const newVM = ClausesUtil.setClauseValue(ownerVM, value, path);
            // eslint-disable-next-line no-param-reassign
            ownerVM.value = newVM.value;
            updateState({});
        },
        [ownerVM && ownerVM.value]
    );

    const updateAndSyncCoverages = async (value, path) => {
        updateCoverage(value, path);
        await syncCoverages(value, path);
    };

    return {
        loadingClause,
        updateCoverage,
        syncCoverages,
        updateAndSyncCoverages,
    };
};
